module.exports = __webpack_public_path__ + "img/gh_pic01-717234.png";